import type { ITableSort } from "app/components/React/Table/types";
import { DefaultCellRightAlign, TimeCell, TrafficShare, WebsiteTooltipTopCell } from "app/components/React/Table/cells";
import { translate } from "app/filters/i18nFilter";
import { PercentageCellRightAlign } from "app/components/React/Table/cells/PercentageCell";
import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";

// 4 is the number of columns without the fixed ones
const OTHER_COLUMNS_WIDTH = `calc( (100% - 0px ) / 4)`;

const columns = [
    {
        field: "Domain",
        width: 185,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.domain",
        tooltip: "demographics.user.based.compare.table.columns.domain.tooltip",
        isResizable: true,
        cellComponent: WebsiteTooltipTopCell,
        fixed: true,
    },
    {
        field: "CompetitiveShare",
        width: 185,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.competitive.share",
        tooltip: "demographics.user.based.compare.table.columns.competitive.share.tooltip",
        isResizable: true,
        cellComponent: TrafficShare,
        fixed: true,
    },
    {
        field: "UniqueVisitorsRatio",
        width: OTHER_COLUMNS_WIDTH,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.audience.share",
        tooltip: "demographics.user.based.compare.table.columns.audience.share.tooltip",
        isResizable: true,
        cellComponent: PercentageCellRightAlign,
        percentageCellFilterFraction: 1,
        headerComponent: DefaultCellHeaderRightAlign,
    },
    {
        field: "Duration",
        width: OTHER_COLUMNS_WIDTH,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.visit.duration",
        tooltip: "demographics.user.based.compare.table.columns.visit.duration.tooltip",
        isResizable: true,
        cellComponent: TimeCell,
        headerComponent: DefaultCellHeaderRightAlign,
    },
    {
        field: "PagesPerVisit",
        width: OTHER_COLUMNS_WIDTH,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.pages.per.visit",
        tooltip: "demographics.user.based.compare.table.columns.pages.per.visit.tooltip",
        isResizable: true,
        cellComponent: DefaultCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
    },
    {
        field: "BounceRate",
        width: OTHER_COLUMNS_WIDTH,
        sortable: true,
        displayNameKey: "demographics.user.based.compare.table.columns.bounce.rate",
        tooltip: "demographics.user.based.compare.table.columns.bounce.rate.tooltip",
        isResizable: true,
        cellComponent: PercentageCellRightAlign,
        headerComponent: DefaultCellHeaderRightAlign,
    },
];

export const getColumns = (sortedColumn: ITableSort) => {
    return columns.map((col) => {
        const isSorted = sortedColumn && col.field === sortedColumn.field;
        const { displayNameKey } = col;
        return {
            ...col,
            visible: true,
            isSorted,
            sortDirection: isSorted ? sortedColumn.sortDirection : "desc",
            displayName: translate(displayNameKey),
        };
    });
};
